Object.assign(window, {
  Int32Array,
  Uint8ClampedArray,
});
